import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=0aa14364&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\clientesapp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa14364')) {
      api.createRecord('0aa14364', component.options)
    } else {
      api.reload('0aa14364', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=0aa14364&", function () {
      api.rerender('0aa14364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/loading/src/loading.vue"
export default component.exports